import styled from 'styled-components';

export const HorizontalSeparator = styled.div`
  width: 100%;
  height: 0px;
  border: 1px solid ${({ theme }) => theme.palette.text.onSurface.inactive};
`;
